// extracted by mini-css-extract-plugin
module.exports = {"listSolution":"Solution_listSolution_2a4Mr","navigation":"Solution_navigation_OcQx3"};